<template>
    <div class="wrapper showtip_wrapper">
        <div class="success_title">
            <p>
                <img src="../../assets/image/jianzhan/finish.png" style="width: 64px" class="jz_finish_img">
            </p>
            <p class="title jz_title">恭喜您赠票成功</p>
            <p class="tip jz_tip">请您注意查收短信或接听客服电话</p>
        </div>
        <div class="card_wrap" style="margin-top: 20px">
            <div class="top_card" style="padding: 0;">
                <div class="new_list_item">
                    <div class="new_right_img tip_left_img">
                        <img src="../../assets/image/jianzhan/zeng.png">
                        <!-- 异形圆角 -->
                        <div class="special coupon_r_t"></div>
                        <div class="special coupon_r_b"></div>
                        <div class="dashed_y"></div>
                    </div>

                    <div class="new_middle_info tip_middle_info">
                        <div class="special coupon_l_t"></div>
                        <div class="special coupon_l_b"></div>
                        <div class="new_middle_inner">
                            <div class="info_title" v-if="theme">{{theme}}</div>
                            <div class="info_desc">
                                <van-icon name="underway-o" />
                                <span class="address_text">{{stime_etime}}</span>
                            </div>
                            <div class="info_desc" v-if="address!=''">
                                <van-icon name="location-o" />
                                <span class="address_text">{{address}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>


    </div>
</template>

<script>
    import _geturl from "@/utils/_geturl";
    import lib_activity from "@/libs/lib_activity";
    import lib_clue from "@/libs/lib_clue";
    import _time from "@/utils/_time";
    import _object from "@/utils/_object";
    import _wx from "@/common/_wx";
    import cache_url from "@/cache/cache_url";
    import _copyUrl from "@/common/_copyUrl";

    export default {
        name: "showtip",
        data() {
            return {
                activity_id: 0, //活动ID
                tids: '', //模板id
                tid: 1, // 5是非汽车行业
                id: 0,
                channel: 0, //渠道ID
                ui: {}, //模板信息
                title: '', //
                share_theme: '', //分享主题
                theme: '',
                stime: 0,
                etime: 0,
                stime_etime: '', // 活动时间
                address: '', // 活动地点
                is_stop: false,
                name: '', //姓名
                phone: undefined, //电话
                brand: '', //品牌
                series: '', //车型
                is_brand: false, //是否有车型
                is_leju_notice: false,

            }
        },

        created() {

            // 地址栏信息
            this.activity_id = _geturl("activity_id");//项目
            this.tids = _geturl("tids");//模板
            this.channel = _geturl("channel");//渠道
            this.id = _geturl('id');

            if(this.activity_id == 691 || this.activity_id == 678) {
                this.is_leju_notice = true
            } else {
                this.is_leju_notice = false
            }

            //获取项目信息
            lib_activity.info(this.activity_id, this.tids, this.init_info);

            // 报名信息
            // lib_clue.info(this.id,this.init_userinfo)

        },
        methods: {

            //初始化项目信息 data是lib_activity.info的response.data
            init_info(data) {
                // console.log(data)
                this.theme = data.activity.theme;
                document.title = '报名成功';
                this.share_theme = data.activity.share_theme;
                this.stime = data.activity.stime;
                this.etime = data.activity.etime;
                this.stime_etime = _time._range_date(this.stime*1000, this.etime*1000);
                this.address = data.activity.address;
                this.tid = data.activity.tid;
                this.ui = data.ui;
                // 项目结束
                if (!data.activity.state || (_time._current() > data.activity.etime)) {
                    this.is_stop = true;
                    return;
                }

                // 分享： ui存在再分享
                if (_object._length(this.ui) > 0) {
                    this.share();
                }
            },


            init_userinfo(data) {
                // console.log(data, '报名信息')
                this.name = data.name;
                this.phone = data.phone;
                if(data.brand_name || data.series_name) {
                    this.is_brand = true
                    this.brand = data.brand_name
                    this.series = data.series_name
                    // this.brand = data.brand_name + ' - ' + data.series_name
                }
            },
            // 分享
            share() {
                let that = this;
                lib_activity.share(function (data) {
                    let options = {};
                    options.title = that.theme;
                    options.desc = that.share_theme;
                    options.link = window.location.href;
                    options.image = that.ui.share;

                    _wx.js_api(data, _wx.share, options);
                })
            },
        }
    }
</script>

<style scoped lang="less">
    @import "../../assets/style/secondary/base.less";
    /*@import "../../assets/style/secondary/showtip";*/
    @import "../../assets/style/secondary/jianzhan";
    @import "../../assets/style/secondary/specialcard";
</style>